module.exports = __webpack_public_path__ + "img/trunk_10x4_z18.4fc342c2.svg";